import { render } from "./PeopleToNotify.html?vue&type=template&id=32cb5d43&scoped=true"
import script from "./PeopleToNotify.js?vue&type=script&lang=js"
export * from "./PeopleToNotify.js?vue&type=script&lang=js"

import "./PeopleToNotify.css?vue&type=style&index=0&id=32cb5d43&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cb5d43"]])

export default __exports__